import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const printHistoryFilterList = (permissions) => {
  const filters = [
    <SelectInput
      key="document_type"
      alwaysOn
      source="document_type"
      label="mine.label.document_type"
      choices={[
        { id: "invoice", name: "mine.document_type.invoice" },
        { id: "delivery_note", name: "mine.document_type.delivery_note" },
        { id: "purchase", name: "mine.document_type.purchase" },
        { id: "sale_return", name: "mine.document_type.sale_return" },
        { id: "purchase_return", name: "mine.document_type.purchase_return" },
      ]}
      emptyText="mine.filter.search_all"
      emptyValue=""
      variant="outlined"
    />,
    <TextInput
      key="code"
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      key="start_date"
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      key="end_date"
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput
      key="user_id"
      source="user_id"
      reference="users"
      alwaysOn
      resettable
    >
      <AutocompleteInput
        label="mine.label.user"
        optionText={(user) =>
          [user.first_name, user.last_name].filter(Boolean).join(" ") ||
          user.username
        }
        variant="outlined"
      />
    </ReferenceInput>,
    <TextInput
      key="reason"
      alwaysOn
      source="reason"
      label="mine.label.reason"
      resettable
      variant="outlined"
    />,
  ];

  if (permissions?.update_company) {
    filters.splice(
      1,
      0,
      <ReferenceInput
        key="company_id"
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }

  return filters;
};

export default printHistoryFilterList;
